import {useState} from 'react';

import {zodResolver} from '@hookform/resolvers/zod';
import {Box, TextField, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {func} from 'prop-types';
import {Controller, useForm} from 'react-hook-form';
import {z} from 'zod';

import {FONT_FAMILIES} from '../../../const';
import useUserSecrets from '../../../hooks/providers/useUserSecrets';
import {secretShape} from '../../../proptypes-shapes';
import Button from '../../form/buttons/Button/Button';
import PasswordInputRevealable from '../../form/PasswordRevealableInput/PasswordInputRevealable';
import UpdateSecretConfirmationModal from '../UpdateSecretConfirmationModal/UpdateSecretConfirmationModla';

const schema = z.object({
  secretValue: z.string().min(1, 'Le secret est obligatoire')
});

const UpdateSecretForm = ({secret, onClose}) => {
  const [isUpdateSecretConfirmationModalOpen, setIsUpdateSecretConfirmationModalOpen] = useState(false);
  const {updateUserSecret} = useUserSecrets();
  const methods = useForm({
    resolver: zodResolver(schema),
    mode: 'all',
    defaultValues: {
      secretValue: ''
    }
  });

  const onSubmit = async formValues => {
    const {secretValue} = formValues;
    const res = await updateUserSecret(secret.secret_name, secretValue);
    if (res.success) {
      methods.reset();
      onClose();
    }
  };

  const {isValid, isSubmitting} = methods.formState;

  const submitButtonDisabled = isSubmitting || !isValid;
  const submitHandler = methods.handleSubmit(onSubmit);

  return (
    <form onSubmit={methods.handleSubmit(onSubmit)}>
      <Box mt={4.5}>
        <Typography fontSize={16} fontFamily={FONT_FAMILIES.TITLE}>
          Saisir le nouveau secret
        </Typography>
        <Grid
          container
          alignItems="center"
          flexWrap="nowrap"
          gap={3}
          sx={{
            mt: 1,
            borderRadius: 2
          }}
        >
          <Controller
            name="secretValue"
            control={methods.control}
            render={({field, fieldState}) => (
              <PasswordInputRevealable
                {...field}
                required
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                label="Nouveau secret"
                placeholder="Tapez ici le nouveau secret..."
                fullWidth
                size="small"
              />
            )}
          />

          <Grid item>
            <Button onClick={() => setIsUpdateSecretConfirmationModalOpen(true)} size="small" disabled={submitButtonDisabled} variant="contained" color="secondary">
              Valider
            </Button>
          </Grid>
        </Grid>
      </Box>

      <UpdateSecretConfirmationModal
        isOpen={isUpdateSecretConfirmationModalOpen}
        onSubmit={submitHandler}
        onClose={() => {
          setIsUpdateSecretConfirmationModalOpen(false);
        }}
      />
    </form>
  );
};

UpdateSecretForm.propTypes = {
  secret: secretShape.isRequired,
  onClose: func.isRequired
};

export default UpdateSecretForm;
